<ng-container *transloco="let t">
  <div class="flex flex-col gap-6">
    <div class="flex items-center gap-4">
      <IMultiSelectMenu
        class="w-72"
        [(value)]="filterIds"
        [(searchQuery)]="searchQuery"
        withSelectOnly
        [popoverWidth]="400"
      >
        <ISelectTrigger>
          <ISelectValue [placeholder]="t('overview.select_strategy')">
            <div *iSelectValue="let value">{{ filterDisplayLabel() }}</div>
          </ISelectValue>
        </ISelectTrigger>
        <ISelectContent>
          <ISelectOption [selectAllOption]="true" />
          <IDropdownMenuSeparator />
          <ISelectOption value="NOT_OPERATED">{{ t("hourly-page.not_operated_campaigns") }}</ISelectOption>
          <IDropdownMenuSeparator />
          @for (strategy of filteredStrategies(); track strategy.strategyId) {
            <ISelectOption [value]="strategy.strategyId">{{ strategy.name }}</ISelectOption>
          }
        </ISelectContent>
      </IMultiSelectMenu>
    </div>

    <app-metric-selector
      [data]="globalData()!"
      [availableMetrics]="CHART_METRICS"
      [localStorageKey]="localStorageKey"
      [showCompare]="false"
      (selectedMetricsChange)="selectedMetrics.set($event)"
    />

    @if (chartDisplayed()) {
      <app-chart-layout closable (closeClicked)="setChartDisplayed(false)">
        <div class="flex w-full flex-col gap-1">
          <IChart [data]="chartData()" [config]="chartConfig()" />
          <div class="mt-3 flex justify-end">
            <div class="text-xs text-gray-500">
              <div>{{ t("hourly-chart.hourly_display") }}</div>
              @if (selectedTimeZone()) {
                <div>{{ t("hourly-chart.hours_displayed", [formattedTimeZone(), timeZoneOffset()]) }}</div>
              }
            </div>
          </div>
        </div>
      </app-chart-layout>
    } @else {
      <div class="flex justify-end">
        <button iButton variant="secondary" [iTooltip]="t('common.show_charts')" (click)="setChartDisplayed(true)">
          <IIcon name="chartLine" />
          {{ t("common.show_charts") }}
        </button>
      </div>
    }
    <app-hourly-table
      [currency]="currency()"
      [locale]="locale()"
      [avgByHour]="avgByTypeHour()"
      [strategies]="strategies()"
      [metric]="selectedMetrics()[0]"
    />
  </div>
</ng-container>
